import { IAsyncActionCreator, createAsyncActionCreator } from '../store/actions/createActionCreator';
import { Delete } from '../utilities/Graft';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { updateItems } from '../store/reducers/itemMapReducer';
import { IFaceted } from '../models/Facet';

/**
 * @public
 */
export interface IClearItemsPayload {
    items: {
        [itemKey: string]: boolean;
    };
}

/**
 * @public
 */
export const clearItems: IAsyncActionCreator<IClearItemsPayload, IItemCacheThunkAction<void>> =
    createAsyncActionCreator((payload: IClearItemsPayload) => {
        const {
            items
        } = payload;

        return (dispatch: IItemCacheDispatch) => {
            const pendingItems: (typeof updateItems.payloadType)['items'] = {};

            for (const itemKey in items) {
                if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                    pendingItems[itemKey] = new Delete<IFaceted>();
                }
            }

            dispatch(updateItems({
                items: pendingItems
            }));
        };
    });
